module.exports = __webpack_public_path__ + "static/media/5.7fc046f6.jpg";